<template>
	<div class="permissions">
		<div class="fx-header">
			<p>权限角色</p>
		</div>
		<div class='permissions-body'>
			<div class='permissions-left'>
				<div class='header'>
					<div class='search-box'>
						<el-input
							size='mini'
							v-model="rtInfo"
							@keyup.enter.native="RoleClassifyReload"
							placeholder="请输入角色分类">
							<i class="el-icon-search el-input__icon" slot="suffix" style=" cursor:pointer"  @click="RoleClassifyReload">
							</i>
						</el-input>
					</div>
					<div class="fx-title">
						<span>角色分类列表</span>
					</div>
				</div>
				<div class='btn-box'>
					<el-button type='primary' v-if="AuthorityList['05_0001_0002_00']" size='small' class='fx-big-btn btn' plain @click='addRoleClassify'>新增</el-button>
				</div>
				<div class='table-box'>
					<el-table
						ref="roleClassifyTable"
						size='mini'
						class="grid-content"
						:data="roleClassifyTableData"
						@row-click='rowClick'
						highlight-current-row
						:height="tableHeight"
						border>
						<el-table-column
							label-class-name = "column-index"
							label="序号"
							type="index"
							width="70"
							align="center">
						</el-table-column>
						<el-table-column
							prop="name"
							label="角色分类"
							align="center"
							min-width="180">
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="200" align="center">
							<template slot-scope="scope">
								<el-button @click="showRoleClassify(scope.row)" size="mini" type='text'><p>查看</p></el-button>
								<el-button @click="deleteRoleClassify(scope.row)" v-if="AuthorityList['05_0001_0004_00'] && !scope.row.defaultflag" size="mini" type='text'><p>删除</p></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class='header1'>
					<div class='search-box'>
						<el-input
							size='mini'
							v-model="rInfo"
							@keyup.enter.native="RoleReload"
							placeholder="请输入角色名称">
							<i class="el-icon-search el-input__icon" slot="suffix" style=" cursor:pointer" @click="RoleReload">
							</i>
						</el-input>
					</div>
					<div class="fx-title">
						<span>角色名称</span>
					</div>
				</div>
				<div class='btn-box'>
					<el-button type='primary' size='small' v-if="AuthorityList['05_0001_0003_00']"  class='fx-big-btn btn' plain @click="addRole">新增</el-button>
				</div>
				<div class='table-box'>
					<el-table
						ref="roleTable"
						size='mini'
						class="grid-content"
						:data="roleTableData"
						:height="tableHeight"
						border>
						<el-table-column width="55" label="选择" align="center" fixed="left">
							<template slot-scope="scope">
								<!-- <el-checkbox v-model="scope.row.status" @change="selectChange(scope.row)" ></el-checkbox> -->
								<el-radio v-model="radioCode" class='radioClass' @change='radioChange(scope.row)' :label='scope.row.id'></el-radio>
							</template>
						</el-table-column>
						<!-- <el-table-column
						type="selection"
						align="center"
						width="55">
						</el-table-column> -->
						<el-table-column
							fixed="left"
							label-class-name = "column-index"
							label="序号"
							type="index"
							width="70"
							align="center">
						</el-table-column>
						<el-table-column
							fixed="left"
							prop="name"
							label="角色名称"
							align="center"
							min-width="170">
						</el-table-column>
						<el-table-column
							prop="rtName"
							label="角色分类"
							align="center"
							min-width="170">
						</el-table-column>
						<el-table-column label="关联员工" width="100" align="center">
							<template slot-scope="scope">
								<el-button @click="personClick(scope.row)" type='text' size="mini">
									<img src="~images/icon/user-active.png"/>
								</el-button>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="200" align="center">
							<template slot-scope="scope">
								<el-button @click="showRole(scope.row)" size="mini" type='text'><p>查看</p></el-button>
								<el-button @click="deleteRole(scope.row)" size="mini" v-if="AuthorityList['05_0001_0005_00'] && !scope.row.defaultflag" type='text'><p>删除</p></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<el-dialog title="角色分类" class="dialog-title" :visible.sync="addRoleClassifyModal" width='350px' :close-on-click-modal="false">
					<span style="color: #F56C6C">*</span>
					<span>角色分类名称：
						<el-input :disabled="!AuthorityList['05_0001_0004_00']"  class="date-input"  :maxlength='10' v-model="roleClassifyName" @blur="roleClassifyNameChange" size='small'></el-input>
					</span>
					<div slot="footer" class="dialog-footer" v-if="AuthorityList['05_0001_0004_00']" >
						<el-button size="medium" type="primary" plain @click="cancelRoleClassify">取 消</el-button>
						<el-button size="medium" type="primary" plain @click="saveRoleClassify">保 存</el-button>
					</div>
				</el-dialog>
				<el-dialog title="角色" class="dialog-title" :visible.sync="addRoleModal" width='350px' :close-on-click-modal="false">
					<div>
						<span style="color: #F56C6C">*</span>
						<span>角色分类：
							<el-select :disabled="!AuthorityList['05_0001_0005_00']"  class="date-input" v-model="roleTypeId" size='small'>
								<el-option
									v-for="item in roleClassifyList"
									:key="item.id"
									:label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</span>
					</div>
					<div style="margin-top:20px">
						<span style="color: #F56C6C">*</span>
						<span>角色名称：
							<el-input :disabled="!AuthorityList['05_0001_0005_00']"  class="date-input" :maxlength='10' v-model="roleName" size='small' @blur="roleNameChange"></el-input>
						</span>
					</div>
					<div slot="footer" class="dialog-footer" :disabled="AuthorityList['05_0001_0005_00']" >
						<el-button size="medium" type="primary" plain @click="cancelRole">取 消</el-button>
						<el-button size="medium" type="primary" plain @click="saveRole">保 存</el-button>
					</div>
				</el-dialog>
				<el-dialog title="关联员工" class="dialog-title" :visible.sync="bindingModal" width='1200px' :close-on-click-modal="false">
					<binding :bindId='bindId' @cancel='cancelPerson' :isShow='bindingModal'></binding>
				</el-dialog>
			</div>
			<div v-if='AuthorityList["05_0001_0001_00"]' class='permissions-right'>
				<tree :treeData='treeData' :treeId='treeId' ></tree>
			</div>
		</div>
	</div>
</template>
<script>
import tree from '@/components/permissions/tree.vue'
import binding from '@/components/permissions/binding.vue'

export default {
	name: 'permissions',
	components: {
		tree, binding
	},
	data () {
		return {
			AuthorityList: {
				'05_0001_0001_00': false,
				'05_0001_0002_00': false,
				'05_0001_0003_00': false,
				'05_0001_0004_00': false,
				'05_0001_0005_00': false
			},
			treeData: {},
			bindId: '',
			radioCode: '',
			treeId: '',
			rtInfo: '',
			rInfo: '',
			rtype: '',
			roleClassifyId: '',
			originRoleClassifyName: '',
			roleId: '',
			roleTypeId: '',
			roleName: '',
			originRoleName: '',
			originRoleTypeName: '',
			showTree: true,
			roleClassifyTableData: [],
			roleClassifyList: [],
			roleTableData: [],
			page: {
				number: 1,
				size: 20
			},
			roleClassifyName: '',
			addRoleClassifyModal: false,
			bindingModal: false,
			addRoleModal: false,
			tableHeight: '100%'
		}
	},
	created () {
		this.init()
		this.getAuthority('05_0001_0000_00')
	},
	methods: {
		roleClassifyNameChange () {
			var reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g
			var res = this.roleClassifyName.replace(reg, '')
			this.roleClassifyName = res
		},
		roleNameChange () {
			var reg = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g
			var res = this.roleName.replace(reg, '')
			this.roleName = res
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		init () {
			this.RoleClassifyReload()
			this.radioChange()
		},
		// 角色
		radioChange (data) {
			let params = {}
			if (data === undefined) {
				params.roleId = ''
				this.radioCode = ''
				this.treeId = ''
			} else {
				params.roleId = data.id
				this.treeId = data.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getRoleAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let data = res.data
					let treeData = {}
					for (let i = 0; i < data.length; i++) {
						treeData[data[i].id] = data[i].moduleAuthority
					}
					this.treeData = treeData
				}
			})
		},
		RoleReload () {
			let params = {
				rInfo: this.rInfo,
				rtype: this.rtype
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getRole`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.roleTableData = res.data
					this.$refs.roleTable.doLayout()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		deleteRole (data) {
			this.$confirm('确认删除该角色', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: data.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/authority/delRole`,
					data: params
				}).then(res => {
					if (res.result === true) {
						this.$message.success('删除成功')
						this.RoleReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		showRole (data) {
			// console.log(data)
			this.roleTypeId = data.rtId
			this.roleName = data.name
			this.roleId = data.id
			this.originRoleName = data.name
			this.originRoleTypeName = data.rtName || ''
			this.addRoleModal = true
			let params = {
				rtInfo: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getRoleType`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.roleClassifyList = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		addRole () {
			this.roleId = ''
			this.roleTypeId = ''
			this.roleName = ''
			this.originRoleName = ''
			this.originRoleTypeName = ''
			this.addRoleModal = true
			let params = {
				rtInfo: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getRoleType`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.roleClassifyList = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		cancelRole () {
			this.addRoleModal = false
		},
		saveRole () {
			if (this.roleTypeId === '') {
				this.$message.error('请选择角色分类')
				return false
			}
			if (this.roleName === '') {
				this.$message.error('角色名称不能为空！')
				return false
			} else {
				var reg = '^[ ]+$'
				var reg1 = new RegExp(reg)
				if (reg1.test(this.roleName)) {
					this.$message({
						type: 'error',
						message: '角色名称不能为空！'
					})
					this.roleName = ''
					return false
				} else {
					let params = {
						id: this.roleId,
						name: this.roleName,
						roleTypeId: this.roleTypeId
					}
					const roleType = this.roleClassifyList.find(item => item.id === this.roleTypeId)
					const typeName = roleType ? roleType.name : ''
					let logger
					if (this.roleId === '') {
						logger = this.$fxLogger.createInfo('authority.role.add', {
							name: this.roleName,
							typeName
						})
					} else {
						logger = this.$fxLogger.createInfo('authority.role.update', {
							name: this.originRoleName,
							preName: this.originRoleName,
							curName: this.roleName,
							preTypeName: this.originRoleTypeName,
							curTypeName: typeName
						})
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlIV}/account/authority/saveOrUpdateRole`,
						data: params,
						logger
					}).then(res => {
						if (res.result === true) {
							this.$message.success('保存成功')
							this.RoleReload()
							this.addRoleModal = false
						} else {
							this.$message.error(res.msg)
						}
					})
				}
			}
		},
		// 角色分类
		rowClick (data) {
			// console.log(data)
			this.rtype = data.id
			this.RoleReload()
			this.radioChange()
		},
		deleteRoleClassify (data) {
			this.$confirm('确认删除该角色分类', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: data.id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/authority/delRoleType`,
					data: params
				}).then(res => {
					if (res.result === true) {
						this.$message.success('删除成功')
						this.RoleClassifyReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		showRoleClassify (data) {
			this.roleClassifyName = data.name
			this.roleClassifyId = data.id
			this.originRoleClassifyName = data.name
			this.addRoleClassifyModal = true
		},
		cancelRoleClassify () {
			this.addRoleClassifyModal = false
		},
		saveRoleClassify () {
			if (this.roleClassifyName === '') {
				this.$message.error('请输入角色分类名称！')
				return false
			} else {
				var reg = '^[ ]+$'
				var reg1 = new RegExp(reg)
				if (reg1.test(this.roleClassifyName)) {
					this.$message({
						type: 'error',
						message: '请输入角色分类名称！'
					})
					this.roleClassifyName = ''
					return false
				} else {
					let params = {
						id: this.roleClassifyId,
						name: this.roleClassifyName
					}
					let logger
					if (this.roleClassifyId === '') {
						logger = this.$fxLogger.createInfo('authority.role.addType', {
							name: this.roleClassifyName
						})
					} else {
						logger = this.$fxLogger.createInfo('authority.role.updateType', {
							preName: this.originRoleClassifyName,
							curName: this.roleClassifyName
						})
					}
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlIV}/account/authority/saveOrUpdateRoleType`,
						data: params,
						logger
					}).then(res => {
						if (res.result === true) {
							this.$message.success('保存成功')
							this.RoleClassifyReload()
							this.addRoleClassifyModal = false
						} else {
							this.$message.error(res.msg)
						}
					})
				}
			}
		},
		addRoleClassify () {
			this.addRoleClassifyModal = true
			this.roleClassifyId = ''
			this.roleClassifyName = ''
			this.originRoleClassifyName = ''
		},
		RoleClassifyReload () {
			let params = {
				rtInfo: this.rtInfo
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getRoleType`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.roleClassifyTableData = res.data
					this.$refs.roleClassifyTable.doLayout()
				} else {
					this.$message.error(res.msg)
				}
			})
			this.rInfo = ''
			this.rtype = ''
			this.RoleReload()
		},
		// 相关员工
		cancelPerson (data) {
			this.bindingModal = data
		},
		personClick (data) {
			this.bindingModal = true
			this.bindId = data.id
		}

	}
}
</script>
<style lang="stylus" scoped>
.permissions{
    display: flex;
    min-width :1100px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
	.permissions-body{
		height:100%;
		display: flex;
		width:100%;
		flex-direction:row;
		.permissions-left{
			display:inline-block;
			height:100%;
			width:100%;
			min-width:600px;
			.header{
				margin-top:10px
				height:35px;
				line-height:35px;
				width:100%;
				.search-box{
					float:right;
					margin-right:20px;
					width:265px
				}
			}
			.header1{
				margin-top:30px
				height:40px;
				line-height:40px;
				width:100%;
				.search-box{
					float:right;
					margin-right:20px;
					width:265px
				}
			}
			.btn-box{
				width:100px;
				min-height:52px;
				line-height:52px;
				.btn{
					margin-left:0px
				}
			}
			.table-box{
				height:25%;
				margin-top:8px;
				min-height:180px;
			}
			.date-input{
				width :150px
			}
			.dialog-footer{
				text-align: center
			}
		}
		.permissions-right{
			display:inline-block;
			height:100%;
			min-width:500px;
		}
	}
}
</style>
<style lang="stylus">
.permissions {
	.dialog-title {
		text-align: left
		.el-dialog__title {
			padding-left 10px
			border-left 5px solid var(--fx-primary-color)
		}
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.table-box{
		.radioClass {
			.el-radio__label{
				display:none
			}
		}

	}


}
</style>
